import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const YonghuZu = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M13 15a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm14 13a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM4 34a8 8 0 0 1 8-8h12a8 8 0 0 1 8 8v8H4v-8Zm8-4a4 4 0 0 0-4 4v4h20v-4a4 4 0 0 0-4-4H12Zm32 4a6 6 0 0 0-6-6h-4v4h4a2 2 0 0 1 2 2v2h-6v4h10v-6Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
